import { useCurrentUser } from 'store/main/hooks';

export function useLoggedIn() {
  const currentUser = useCurrentUser();
  return currentUser && currentUser.email !== null;
}
